export class OblEncomendaService {
    $q;
    OblInteracaoOrcamentacao;
    FuncionarioEntidadeProprietaria;
    constructor($q, OblInteracaoOrcamentacao, FuncionarioEntidadeProprietaria) {
        this.$q = $q;
        this.OblInteracaoOrcamentacao = OblInteracaoOrcamentacao;
        this.FuncionarioEntidadeProprietaria = FuncionarioEntidadeProprietaria;
    }
    table(query) {
        return this.OblInteracaoOrcamentacao.table(query).$promise;
    }
    options() {
        return this.OblInteracaoOrcamentacao.options().$promise;
    }
    export(query) {
        return this.OblInteracaoOrcamentacao.export(query).$promise;
    }
    findTecnicos() {
        const defer = this.$q.defer();
        this.FuncionarioEntidadeProprietaria.find({
            filter: {
                where: {
                    entidadeProprietariaId: 3,
                    active: true
                },
                include: {
                    relation: 'funcionario'
                }
            }
        })
            .$promise.then(f => {
            const users = [];
            f.forEach(r => {
                if (r.funcionario) {
                    users.push(r.funcionario);
                }
            });
            defer.resolve(users.sort((a, b) => a.name.localeCompare(b.name)));
        })
            .catch(e => {
            defer.reject(e);
        });
        return defer.promise;
    }
}
OblEncomendaService.$inject = ['$q', 'OblInteracaoOrcamentacao', 'FuncionarioEntidadeProprietaria'];
